export default "__VITE_ASSET__DI1v_kNO__"